
import { useForm } from "react-hook-form"
import type { User } from "firebase/auth"
import type { LiveId, SpaceKey } from "popopo-msg"
import { api } from "../../core"
import { useToast } from "popopo-lib-front/hook"
import { UploadToFireStorageInput } from "../UploadToFireStorageInput"
import { FirebaseStoragePaths } from "popopo-msg"

type SpaceLiveCommentCreateForms = {
  kind: "text"
  value: string
} | {
  kind: "emotion"
  value: string
} | {
  kind: "image"
  value: string
}

export const SpaceLiveCommentCreateForm = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId }) => {
  const form = useForm<SpaceLiveCommentCreateForms>({
    mode: "onBlur",
    defaultValues: {
      kind: "text",
      value: "",
    },
  })
  const toast = useToast()
  const { spaceKey, liveId } = props

  const onSubmit = async (value: SpaceLiveCommentCreateForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.POST("/api/v2/spaces/{space_key}/lives/{live_id}/comments", {
        params: { path: { space_key: spaceKey, live_id: liveId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: { ...value },
      })
      if (res.error) {
        toast.add({ type: "danger", title: "コメント送信失敗", message: `送信できませんでした ${JSON.stringify(res.error)}` })
        console.error(res.error)
      }
    } catch (e) {
      toast.add({ type: "danger", title: "コメント送信失敗", message: `送信できませんでした ${JSON.stringify(e)}` })
      console.error(e)
    }
  }

  const kind = form.watch("kind")
  const { isSubmitting, isValid } = form.formState

  return (
    <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
      <div className="form-floating">
        <select className="form-control" disabled={isSubmitting} {...form.register("kind")}>
          <option value={"text"}>text</option>
          <option value={"emotion"}>emotion</option>
          <option value={"image"}>image</option>
        </select>
        <label>Kind</label>
      </div>

      <div className="form-floating">
        {(kind === "text" || kind === "emotion") ? (
          <>
            <input className="form-control" {...form.register("value")} disabled={isSubmitting} />
            <label>Message</label>
          </>
        ) : (
          <UploadToFireStorageInput
            label="File"
            uploadPath={`/${FirebaseStoragePaths.LiveComment.getPathUploaded(props.firebase.uid, spaceKey, liveId, kind)}`}
            onChange={(successfullyUploaded) => {
              if (!successfullyUploaded) {
                form.setError("value", { message: "ファイルが指定されていません。" })
              }
            }}
            disabled={isSubmitting} />
        )}
      </div>

      <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
        Send comment
      </button>
    </form>
  )
}
